<ion-content *ngIf="geladen" #content class="section-content auftragstyp-wareneingang">

  <div *ngIf="isAbgeschlossen" class="archiv-message">ARCHIV</div>

  <!-- Button zum Hinzufügen einer Position. Wird nicht benötigt. Soll über die Lieferung-Details gemacht werden -->
  <ion-fab vertical="bottom" horizontal="end" slot="fixed">
    <ion-fab-button appClick (clicked)="onBarcodeScan()" color="dark" *ngIf="!isAbgeschlossen && isLieferantAusgewaehlt">
      <ion-icon name="barcode"></ion-icon>
    </ion-fab-button>

    <!-- <ion-fab-button appClick (clicked)="onNeuePosition()" color="primary" *ngIf="!isAbgeschlossen && isLieferantAusgewaehlt">
      <ion-icon name="add"></ion-icon>
    </ion-fab-button> -->
  </ion-fab>

  <!-- Lieferant auswählen -->
  <auftrag-lieferant-komponente
                                [auftragdetails]="auftragdetails"
                                [adresse]="auftrag.Erzeugeradresse"
                                (lieferantChanged)="onLieferantChanged($event)"></auftrag-lieferant-komponente>

  <div *ngIf="isLieferantAusgewaehlt">

    <!-- Bestellung auswählen. Wird derzeit nicht benötigt -->
    <!-- <div class="section">
      <h1>Bestellung / Lieferung</h1>

      <ion-item lines="none" *ngIf="auftrag.Erzeugeradresse?.Name1">
        <ion-select placeholder="{{ 'Bitte Lieferung wählen' | translate }}" [(ngModel)]="lieferung" [okText]="'OK' | translate" [cancelText]="'Abbrechen' | translate" (ionChange)="onLieferungChanged()">
          <ion-select-option [value]="null">(keine)</ion-select-option>
          <ion-select-option *ngFor="let p of bestellungen" [value]="p">
            {{ p.AAbholdatum }}, Nr: {{ p.Auftragsnummer }}, {{ p.Info1 }}
          </ion-select-option>
        </ion-select>
      </ion-item>
    </div> -->

    <div *ngFor="let c of formularKonfiguration.komponenten">
      <div [ngSwitch]="c.name">
        <!-- Fahrzeug-Kennzeichen -->
        <fahrzeug-kennzeichen-komponente *ngSwitchCase="'Fahrzeug-Kennzeichen'" [auftragdetails]="auftragdetails" [komponente]="c"></fahrzeug-kennzeichen-komponente>

        <!-- Barcode -->
        <auftrag-barcode-komponente *ngSwitchCase="'Barcode'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-barcode-komponente>

        <!-- Lieferung -->
        <auftrag-lieferung-komponente *ngSwitchCase="'Lieferung'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-lieferung-komponente>

        <!-- Leergut -->
        <auftrag-leergut-komponente *ngSwitchCase="'Leergut'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-leergut-komponente>

        <!-- Hinweistexte -->
        <auftrag-hinweistexte-komponente *ngSwitchCase="'Hinweistexte'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-hinweistexte-komponente>

        <!-- Auftragsbilder -->
        <auftrag-bilder-komponente *ngSwitchCase="'Bilder'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-bilder-komponente>

        <!-- Bilder (Wareneingang) -->
        <auftrag-bilder2-komponente *ngSwitchCase="'Bilder2'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-bilder2-komponente>

        <!-- Anmerkungen-->
        <auftrag-anmerkungen-komponente *ngSwitchCase="'Anmerkungen'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-anmerkungen-komponente>

        <!-- Ext. Auftragsnummer-->
        <auftrag-ext-nummer-komponente *ngSwitchCase="'Ext-Nummer'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-ext-nummer-komponente>

        <!-- Unterschrift -->
        <auftrag-unterschrift-komponente *ngSwitchCase="'Unterschrift'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-unterschrift-komponente>

        <!-- Statusmeldung -->
        <auftrag-statusmeldungen-komponente *ngSwitchCase="'Statusmeldungen'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-statusmeldungen-komponente>

        <!-- Checkliste -->
        <auftrag-checkliste-komponente *ngSwitchCase="'Checkliste'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-checkliste-komponente>

        <!-- Dateien -->
        <auftrag-dateien-komponente *ngSwitchCase="'Dateien'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-dateien-komponente>

        <!-- Buttons -->
        <auftrag-buttons-komponente *ngSwitchCase="'Buttons'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-buttons-komponente>

      </div>
    </div>
  </div>

  <!-- <div class="section buttons-section buttons-section-normal" *ngIf="isDebugButtonsAnzeigen">

    <ion-button appClick (clicked)="onSimuliereBarcode('GS1-128', '020401871506013033020713003740')" expand="full" color="light" class="status-button">
      SIN Cola A
    </ion-button>
    <ion-button appClick (clicked)="onSimuliereBarcode('GS1-128', '152209241020210823302090000013')" expand="full" color="light" class="status-button">
      SIN Cola B
    </ion-button>
    <ion-button appClick (clicked)="onSimuliereBarcode('GS1-128', '00341011300399984111')" expand="full" color="light" class="status-button">
      SIN Cola NVE
    </ion-button>
    <ion-button appClick (clicked)="onSimuliereBarcodeAB()" expand="full" color="light" class="status-button">
      SIN Cola A + B
    </ion-button>
    <ion-button appClick (clicked)="onSimuliereBarcode('GS1-128', '020406930000700933020713003705')" expand="full" color="light" class="status-button">
      5x CO2 lang 10 kg
    </ion-button>

    <ion-button appClick (clicked)="onSimuliereBarcode('GS1-128', '02040187150044311522060637401020210906301120000443')" expand="full" color="light" class="status-button">
      RANGAU QUELLE classic 12 x 0.70
    </ion-button>
    <ion-button appClick (clicked)="onSimuliereBarcode('GS1-128', '0204018715060130100XX0000')" expand="full" color="light" class="status-button">
      Sinalco Cola 24 x 0,33 l
    </ion-button>
    <ion-button appClick (clicked)="onSimuliereBarcode('GS1-128', '0204018715060161100XX0000')" expand="full" color="light" class="status-button">
      Sinalco Cola Mix 24 x 0,33 l
    </ion-button>
    <ion-button appClick (clicked)="onSimuliereBarcode('GS1-128', '0204018715082514100XX0000')" expand="full" color="light" class="status-button">
      Sinalco Orange 12 x 0,5 l
    </ion-button>
    <ion-button appClick (clicked)="onSimuliereBarcode('GS1-128', '0204018715082576100XX0000')" expand="full" color="light" class="status-button">
      Sinalco Cola Mix 12 x 0,5 l
    </ion-button>
    <ion-button appClick (clicked)="onSimuliereBarcode('GS1-128', '0204018715082552100XX0000')" expand="full" color="light" class="status-button">
      Sinalco Apfelschorle 12 x 0,5
    </ion-button>
    <ion-button appClick (clicked)="onSimuliereBarcode('GS1-128', '0204018715004189100XX0000')" expand="full" color="light" class="status-button">
      Sinalco Orange 12 x 1,0 l
    </ion-button>
  </div> -->
</ion-content>

<div *ngIf="anzeigeBild" class="anzeigebild">
  <pinch-zoom>
    <img class="bild" [src]="domSanitizationService.bypassSecurityTrustUrl(anzeigeBild.src)" />
  </pinch-zoom>

  <ion-button expand="full" fill="clear" appClick (clicked)="onBildClicked(null)">
    <ion-ripple-effect></ion-ripple-effect>
    <ion-icon name="close"></ion-icon> Schließen
  </ion-button>
</div>